import { API, setAuthToken } from '../../../config/API.js';
import {
  GET_DATA_PROP_DEV,
  GET_TIPE_PROP_DEV,
  SET_LOADING_DATA_PROP_DEV,
  SET_LOADING_TIPE_PROP_DEV,
  SET_PAGINATION_DATA_PROP_DEV,
  SET_PAGINATION_TIPE_PROP_DEV,
} from '../constant.js';

export const getTipePropDev = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_TIPE_PROP_DEV,
      payload: true,
    });
    API.get(
      `admin/property/development/type?${new URLSearchParams(
        params
      ).toString()}`
    )
      .then((res) => {
        dispatch({
          type: GET_TIPE_PROP_DEV,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_TIPE_PROP_DEV,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_TIPE_PROP_DEV,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_TIPE_PROP_DEV,
          payload: 0,
        });
      });
  };
};

export const addTipePropDev = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/development/type/add", params);
};

export const getDetailTipePropDev = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/property/development/type/${code}`);
};

export const updTipePropDev = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/development/type/edit", params);
};

export const delTipePropDev = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/property/development/type/delete/" + code);
};

export const getDataPropDev = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_DATA_PROP_DEV,
      payload: true,
    });
    API.get(
      `admin/property/development?${new URLSearchParams(params).toString()}`
    )
      .then((res) => {
        dispatch({
          type: GET_DATA_PROP_DEV,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_PROP_DEV,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_DATA_PROP_DEV,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_DATA_PROP_DEV,
          payload: 0,
        });
      });
  };
};

export const addDataPropDev = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/development/add", params);
};

export const getDetailDataPropDev = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/property/development/${code}`);
};

export const updDataPropDev = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/property/development/edit", params);
};

export const delDataPropDev = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/property/development/delete/" + code);
};
